import { Bolseiro } from './../../api/models/bolseiro.model';
import {
  Component,
  inject,
  OnDestroy,
  OnInit,
  Output,
  EventEmitter,
  ViewChild,
} from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import {
  PaisService,
  ProvinciaService,
  MunicipioService,
  CommunicationService,
  BolseiroService,
  EnumService,
} from '../../api/services';
import { Router, RouterLink, RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiService } from '@core/providers/http';
import { MessageService, MenuItem } from 'primeng/api';
import { CardPersonBolseirosComponent } from '@app/shared/components/card-person-bolseiros/card-person-bolseiros.component';
import { SearchBarComponent } from '../../../../../shared/components/search-bar/search-bar.component';
import { CardPersonComponent } from '../../../../../shared/components/card-person/card-person.component';
import { CadastrarBolseirosComponent } from '../cadastrar-bolseiros/cadastrar-bolseiros.component';
import { Utilizador } from '../../api/models/utilizador.model';
import { ToastModule } from 'primeng/toast';
import { FilterItem } from '../../api/models/filterItem.model';
import { CommonModule } from '@angular/common';
import { PaginatorModule } from 'primeng/paginator';
import {
  FormsModule,
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import { Pagination } from '../../../../../shared/model/pagination.model';
import { PaginatorControlComponent } from '@app/shared/components/paginator-control/paginator-control.component';
import { Menu } from 'primeng/menu';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialog } from 'primeng/confirmdialog';
import {
  TableColumn,
  TableComponent,
} from '../../../../../shared/components/table/table.component';
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { Button } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { BackButtonComponent } from '@app/shared/components/back-button/back-button.component';
import { AuthStore } from '@core/service/auth-store.service';

@Component({
  selector: 'app-lista-bolseiros',
  templateUrl: './lista-bolseiros.component.html',
  styleUrls: ['./lista-bolseiros.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    SearchBarComponent,
    CardPersonComponent,
    ToastModule,
    PaginatorModule,
    FormsModule,
    CardPersonBolseirosComponent,
    TableComponent,
    PaginatorControlComponent,
    RouterLink,
    DataVoidComponent,
    RouterModule,
    CadastrarBolseirosComponent,
    ReactiveFormsModule,
    Menu,
    DialogModule,
    SelectModule,
    Button,
    InputTextModule,
    ConfirmDialog,
    BackButtonComponent,
  ],
  providers: [
    DialogService,
    ApiService,
    PaisService,
    ProvinciaService,
    MunicipioService,
    CommunicationService,
    BolseiroService,
    MessageService,
    EnumService,
    ConfirmationService,
  ],
})
export class ListaBolseirosComponent implements OnInit, OnDestroy {
  dialogService = inject(DialogService);
  paisService = inject(PaisService);
  provinciaService = inject(ProvinciaService);
  municipioService = inject(MunicipioService);
  communicationService = inject(CommunicationService);
  confirmationService = inject(ConfirmationService);
  bolseiroService = inject(BolseiroService);
  messageService = inject(MessageService);
  enumService = inject(EnumService);
  isLoading: boolean = false;
  private router = inject(Router);
  private auth = inject(AuthStore);
  countries: any[] = [];
  provinces: any[] = [];
  municipalities: any[] = [];
  bolseiros: Bolseiro[] = [];
  utilizadores: Utilizador[] = [];
  private subscriptions = new Subscription();
  sortFields: any[] = [
    {
      label: 'Nome',
      value: 'nome',
    },
  ];
  estados = [
    { id: 'ativo', designacao: 'Activo' },
    { id: 'inativo', designacao: 'Inactivo' },
  ];
  // totalEstudantesInativos: number = 0;
  tiposDeBolsa = [
    { id: 'parcial', designacao: 'Parcial' },
    { id: 'integral', designacao: 'Integral' },
  ];

  constructor(public fb: FormBuilder) {
    this.loadCountries();
  }

  form!: FormGroup;

  nacionalidades = [
    { label: 'Angola', id: 1 },
    { label: 'Namibiana', id: 2 },
  ];

  estadoCivilOptions = [
    { label: 'Solteiro', id: 5 },
    { label: 'Casado', id: 1 },
  ];

  generoOptions = [
    { label: 'Masculino', id: 1 },
    { label: 'Feminino', id: 2 },
  ];

  idadeOptions = Array.from({ length: 35 - 15 + 1 }, (_, i) => ({
    label: `${i + 20} anos`,
    id: i + 20,
  }));

  nivelAcademicoOptions: any[] = [];

  provincias = [
    { label: 'Luanda', id: 1 },
    { label: 'Benguela', id: 2 },
    { label: 'Huambo', id: 3 },
  ];

  municipios = [
    { label: 'Cazenga', id: 1 },
    { label: 'Viana', id: 2 },
    { label: 'Cacuaco', id: 3 },
  ];
  pagination: Pagination<any> = new Pagination<any>();
  actions: MenuItem[] = [
    {
      label: 'Ver Detalhes do Estudante',
      icon: 'pi pi-info-circle',
      command: ($event: any) => this.callRouteDetailsBolseiro($event.item.data),
    },
    {
      label: 'Editar Estudante',
      icon: 'pi pi-pencil',
      command: ($event: any) => this.callRouteEditBolseiro($event.item.data),
    },
    {
      label: 'Atribuir Auxilio de Formação',
      icon: 'pi pi-arrow-circle-right',
      command: ($event: any) => this.GotoAuxForm($event.item.data),
    },
    {
      label: 'Eliminar Estudante',
      icon: 'pi pi-times',
      command: ($event: any) => this.deleteBolseiro($event.item.data),
    },
    {
      label: 'Reactivar a conta',
      icon: 'pi pi-key',
      command: ($event: any) => this.rectiveAccount($event.item.data),
    },
  ];
  @ViewChild('menu') menu!: Menu;
  columns: TableColumn[] = [
    { field: 'nome', header: 'Nome do Estudante', type: 'text' },
    { field: 'numeroBI', header: 'Bilhete de Identidade', type: 'text' },
    { field: 'idade', header: 'Idade', type: 'text' },
    { field: 'generoDescricao', header: 'Género', type: 'text' },
    {
      field: 'nivelAcademicoBolseiroDescricao',
      header: 'Nível Académico',
      type: 'text',
    },
    { field: 'email', header: 'E-mail', type: 'text' },

    // {
    //   field: 'totalBolsas',
    //   header: 'Nº de Auxílios de Formação',
    //   type: 'badge',
    //   severityField: 'totalBolsas',
    //   badgeSeverityFunction: () =>'info',
    // },
  ];

  callRouteDetailsBolseiro(data: any) {
    this.router.navigate([
      '/gestao-bolseiros/bolseiros/detalhe-bolseiro/',
      data?.id,
    ]);
  }

  callRouteEditBolseiro(data: any) {
    if (this.auth.hasAny(['actualizar_registo_estudante'])) {
      this.router.navigate(['gestao-bolseiros/bolseiros/cadastrar-bolseiro'], {
        queryParams: {
          bolseiroId: data.id,
        },
      });
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Permissão Inválida',
        detail: 'Não tens permissão para efetuar esta acção',
        life: 3000,
      });
    }
  }

  deleteBolseiro(data: any) {
    if (this.auth.hasAny(['desactivar_estudante'])) {
      this.confirmationService.confirm({
        message: `Tem certeza que deseja eliminar o estudante "${data.nome}"?`,
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: () => {
          this.bolseiroService.toggleStatus(data?.id).subscribe(() => {
            this.getAllBolseiros();
            this.messageService.add({
              severity: 'success',
              summary: 'Sucesso',
              detail: 'Estudante eliminado com sucesso!',
              life: 3000,
            });
          });
        },
      });
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Permissão Inválida',
        detail: 'Não tens permissão para efetuar esta acção',
        life: 3000,
      });
    }
  }

  onActionSelected(event: any) {
    const { event: actionEvent, rowData } = event;
    this.actions
      .find((action) => action.label === actionEvent.item.label)
      ?.command?.({ item: rowData });
  }

  filters: FilterItem[] = [
    {
      type: 'text',
      controlName: 'nome',
      placeholder: 'Pesquise por nome',
    },
    {
      type: 'text',
      controlName: 'NumeroBI',
      placeholder: 'Pesquise por BI',
    },
    {
      type: 'dropdown',
      controlName: 'genero',
      placeholder: 'Selecione o género',
      options: this.generoOptions,
      optionLabel: 'label',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'nivelAcademicoID',
      placeholder: 'Selecione o nível académico',
      options: this.nivelAcademicoOptions,
      optionLabel: 'designacao',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'idade',
      placeholder: 'Selecione a idade',
      options: this.idadeOptions,
      optionLabel: 'label',
      optionValue: 'id',
    },
  ];

  ngOnInit() {
    this.getAllBolseiros();
    this.loadNivelAcademicoEnum();
    this.subscriptions.add(
      this.communicationService.countryChanged$.subscribe(
        (country: string | null) => {
          if (country) {
            this.loadProvinces(country);
          }
        },
      ),
    );

    this.subscriptions.add(
      this.communicationService.provinceChanged$.subscribe(
        (province: string | null) => {
          if (province) {
            this.loadMunicipalities(province);
          }
        },
      ),
    );

    this.form = this.fb.group({
      nome: [null],
      NumeroBI: [null],
      genero: [null],
      nivelAcademicoID: [null],
      idade: [null],
    });
  }

  GotoAuxForm(data: any) {
    this.router.navigate([
      '/gestao-bolseiros/auxilio-formacao/cadastrar-auxilio-formacao/' +
        data?.numeroBI,
    ]);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  loadCountries() {
    this.paisService.list().subscribe((countries) => {
      this.countries = countries;
    });
  }

  loadProvinces(country: string) {
    this.provinciaService.list(country).subscribe((provinces) => {
      this.provinces = provinces;
      this.communicationService.updateProvinces(provinces);
      this.municipalities = []; // Reset municipalities when country changes
    });
  }

  loadMunicipalities(province: string) {
    this.municipioService.list(province).subscribe((municipalities) => {
      this.municipalities = municipalities;
      this.communicationService.updateMunicipalities(municipalities);
    });
  }

  totalBolseiros: number = 0;

  getAllBolseiros(queryParams?: any) {
    this.isLoading = true;
    const params = {
      ...queryParams,
      pageNumber: this.pagination.pageNumber ?? 1,
      pageSize: this.pagination.pageSize ?? 10,
      OrderBy: queryParams?.OrderBy || 'id desc',
    };

    this.bolseiroService.list(params).subscribe(
      (response) => {
        this.pagination = new Pagination<any>().deserialize(response);
        this.totalBolseiros = response.totalRecords;
        this.isLoading = false;
      },
      (error: any) => {
        console.error('Erro ao buscar bolseiros:', error);
        this.isLoading = false;
        this.messageService.add({
          severity: 'Error',
          summary: 'Erro',
          detail: 'Erro ao buscar estudantes',
          life: 3000,
        });
      },
    );
  }

  get totalEstudantes() {
    return this.totalBolseiros;
  }

  callRouteCreateBolseiro() {
    if (this.auth.hasAny(['registar_estudante'])) {
      this.router.navigate(['gestao-bolseiros/bolseiros/cadastrar-bolseiro']);
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Permissão Inválida',
        detail: 'Não tens permissão para efetuar esta acção',
        life: 3000,
      });
    }
  }

  loadNivelAcademicoEnum() {
    this.enumService
      .getAllNivelAcademicoMIREMPETEnum()
      .subscribe((response) => {
        if (response?.data) {
          this.nivelAcademicoOptions = Object.entries(response.data).map(
            ([key, value]) => ({
              id: Number(key),
              designacao: value,
            }),
          );
          this.filters[3].options = this.nivelAcademicoOptions;
        }
      });
  }

  showDialog() {
    const ref = this.dialogService.open(CadastrarBolseirosComponent, {
      showHeader: false,
      width: '50%',
      modal: true,
      data: {
        utilizadores: this.utilizadores,
        nacionalidades: this.nacionalidades,
        estadoCivilOptions: this.estadoCivilOptions,
        generoOptions: this.generoOptions,
        nivelAcademicoOptions: this.nivelAcademicoOptions,
        provincias: this.provincias,
        municipios: this.municipios,
        tiposDeBolsa: this.tiposDeBolsa,
        estados: this.estados,
        bolseiros: this.bolseiros,
        provinces: this.provinces,
        municipalities: this.municipalities,
        countries: this.countries,
      },
    });

    ref.onClose.subscribe((data) => {
      if (data) {
        this.storeBolseiro(data);
      }
    });
  }

  storeBolseiro(data: any) {
    this.isLoading = true; // Iniciar carregamento

    let formData = new FormData();
    formData.append('nome', data.nome);
    formData.append('dataEmissaoBI', data.dataEmissaoBI);
    formData.append('dataVencimentoBI', data.dataVencimentoBI);
    formData.append('dataNascimento', data.dataNascimento);
    formData.append('numeroBI', data.numeroBI);
    formData.append('estadoCivil', data.estadoCivil);
    formData.append('genero', data.genero);
    formData.append('nivelAcademicoID', data.nivelAcademicoID);
    formData.append('paisNascimento', data.paisNascimento);
    formData.append('nomeMae', data.nomeMae);
    formData.append('nomePai', data.nomePai);
    formData.append('idProvinciaResidencia', data.idProvinciaResidencia);
    formData.append('idMunicipioResidencia', data.idMunicipioResidencia);
    formData.append('idMunicipioNascimento', data.idMunicipioNascimento);
    formData.append('contactoPrincipal', data.contactoPrincipal);
    formData.append('enderecoResidencia', data.enderecoResidencia);
    formData.append('endereco', data.endereco);
    formData.append('email', data.email);
    formData.append('contactoFamiliar', data.contactoFamiliar);
    formData.append('contactoSecundario', data.contactoSecundario);
    formData.append('isActive', data.isActive);
    formData.append('fotoBase64', data.fotoBase64);

    this.bolseiroService.store(formData).subscribe(
      (response) => {
        this.isLoading = false; // Parar carregamento
        // this.getAllBolseiros();
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Bolseiro criado com sucesso!',
        });
      },
      (error) => {
        console.error('Erro ao criar bolseiro:', error);
        this.isLoading = false; // Parar carregamento
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao criar bolseiro.',
        });
      },
    );
  }

  handleFormValueChange(event: any) {
    const filters = Object.fromEntries(
      Object.entries(event).filter(
        ([_, value]) => value !== null && value !== undefined && value !== '',
      ),
    );
    console.log('Filtered values:', filters);
    this.getAllBolseiros(filters);
    this.showFilter = false;
  }

  trackByBolseiroId(index: number, item: Bolseiro): number {
    return item.id; // Supondo que cada Bolseiro tem um campo 'id' único
  }

  onPageChange(event: any) {
    this.pagination.pageNumber = event.page + 1;
    this.pagination.pageSize = event.rows;
    this.getAllBolseiros();
  }

  showFilter: boolean = false;

  showFilterModal() {
    this.showFilter = true;
  }

  rectiveAccount(bolseiro: any) {
    console.log(bolseiro);

    if (this.auth.hasAny(['ESTUDANTES'])) {
      this.confirmationService.confirm({
        message: `Tem certeza que deseja reactivar o estudante "${bolseiro.nome}"?`,
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: () => {
          this.bolseiroService.reactivar(bolseiro?.id).subscribe(() => {
            this.getAllBolseiros();
            this.messageService.add({
              severity: 'success',
              summary: 'Sucesso',
              detail: 'Estudante reactivado com sucesso!',
              life: 3000,
            });
          });
        },

        reject: () => {},
      });
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Permissão Inválida',
        detail: 'Não tens permissão para efetuar esta acção',
        life: 3000,
      });
    }
  }
}
